<template>
  <div>
    <img
      style="width: 50px"
      :src="sistemurl + data.images"
      alt=""
      @click="
        $router
          .push({
            name: 'ecommerce-item-detail-view',
            params: { item_id: data.maddeKodu },
          })
          .catch(() => {})
      "
    />
  </div>
</template>
      <script>
import Store from "../../../store/store";
import state from "../../../store/state";
export default {
  data() {
    return {
      VALUE: "",
      sistemurl: Store.state.imgurl,
      data: [],
    };
  },
  created() {
    this.data = this.params.data;
    this.VALUE = this.params.value;
  },
};
</script>
      